import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { TimesheetOvertimeRequestDocument } from 'generated/resources/graphql'
import moment from 'moment'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import { dateToString } from 'modules/core/lib/dates'

import EditOvertimeRequestModal from 'modules/attendance/components/ClockIn/Modals/OvertimeRequest/Edit'

const EditOvertimeRequestPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { year, month, day, employeeId, periodType } = useStrictParams<
    'year' | 'month' | 'day' | 'employeeId' | 'periodType'
  >()
  const currentDate = moment([Number(year), Number(month) - 1, Number(day)])
  const startOn = dateToString(currentDate, 'backend')

  const onClose = () => {
    navigate(
      navigation.timeTracking.employee.periodTypeYearMonthDayEmployeeId.fullPath({
        periodType,
        year,
        month,
        day,
        employeeId,
      })
    )
  }

  const { data } = useQuery(TimesheetOvertimeRequestDocument, {
    variables: {
      employeeIds: [+employeeId],
      startOn,
    },
  })

  const overtimeRequest = data?.attendance?.overtimeRequests?.[0]

  return (
    <>
      {overtimeRequest && (
        <EditOvertimeRequestModal overtimeRequest={overtimeRequest} onClose={onClose} />
      )}
    </>
  )
}

export default EditOvertimeRequestPage
